<template>
  <div class="index">
    <!-- 筛选 -->
    <FilterBox
      ref="FilterBox"
      :formItems="formItems"
      :filterForm="filterForm"
      :areaChange="areaChange"
      :filterClick="filterClick"
      :resetClick="resetClick" />
    <!-- 数据表格 -->
    <TableBox
      ref="TableBox"
      :formItems="formItems"
      :tableData="tableData"
      :currentChange="currentChange"
      :pageData="pageData"
      :pageChange="pageChange"
      :showSelection="false" />
  </div>
</template>

<script>
import FilterBox from '@/components/XY/FilterBox'
import TableBox from '@/components/XY/TableBox'
import mixin_table from '@/Mixins/mixin_table'

export default {
  mixins: [mixin_table],
  components: { FilterBox, TableBox },
  data() {
    return {
      sign: 'yiliaofuwu_hjtj',
      dialogTitle: '呼叫统计',

      formItems: [
        {
          fType:'xy_text',fShow:true,
          label:'地区',key:'fixed-area',
        }, {
          fType:'xy_daterange',fShow:true,fDefault:this.fillDefaultTime,
          label:'统计时间',key:'createTime',
        }, {
          fType:'xy_radio',fShow:true,fDefault:1,
          label:'报表类型',key:'reportType',
          options:[{label:'汇总',value:1},{label:'按天',value:2}],
          callback:this.reportTypeChange
        }, {
          fType:'xy_select',fShow:false,
          label:'协作人',key:'queryUserName',
          options:['邓晓梅','李晓红','杨阳','张如意','魏倩','黄丹','向雪','黄梦琦','殷悦','杨汶涓','辜诗涵'],multiple:true,
        }, {
          tType:'xy_text',tShow:true,
          label:'用户名',key:'userName',
        }, {
          tType:'xy_text',tShow:false,
          label:'日期',key:'reportDate',
        }, {
          tType:'xy_text',tShow:true,
          label:'总的呼叫次数',key:'count',
        }, {
          tType:'xy_text',tShow:true,
          label:'接通次数',key:'passCount',
        }, {
          tType:'xy_text',tShow:true,
          label:'接通率',key:'passPercent_',
        }, {
          tType:'xy_text',tShow:true,
          label:'通话时长',key:'duration_',
        }, {
          tType:'xy_text',tShow:true,
          label:'有效呼出次数',key:'validCount',
        }, {
          tType:'xy_text',tShow:true,
          label:'有效呼出时长',key:'validDuration_',
        }, {
          tType:'xy_text',tShow:true,
          label:'平均时长',key:'avgCall_',
        },
      ],
    }
  },
  methods: {
    getData(rD = {}) {
      if (!rD.startCreateTime || !rD.endCreateTime) {
        this.$message.error('请选择开始时间和结束时间！')
        return null
      }
      return this.$api.callReport(rD).then(res => {
        if (res.data.status == 0) {
          const _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.formItems[5].tShow = rD.reportType === 2
          this.tableData = _R.map(x1 => {
            x1.passPercent_ = (x1.passPercent * 100).toFixed(2) + '%'
            x1.duration_ = this.$t.formatMilliseconds(x1.duration || 0)
            x1.validDuration_ = this.$t.formatMilliseconds(x1.validDuration || 0)
            x1.avgCall_ = this.$t.formatMilliseconds(x1.avgCall || 0)
            return x1
          })
          return res
        } else { this._status(res.data) }
      })
    },
    fillDefaultTime() {
      const { startTimestamp, endTimestamp } = this.$t.getStartAndEndTimestamp();
      // this.$set(this.filterForm, 'createTime', [startTimestamp, endTimestamp])
      return [startTimestamp, endTimestamp]
    },
    reportTypeChange(key, e) {
      if (e === 2) {
        this.formItems[3].fShow = true
      } else {
        this.formItems[3].fShow = false
        this.filterForm.queryUserName = []
      }
    },
  },
}
</script>

<style lang='scss' scoped>
</style>